import Swiper from 'swiper/bundle';
import GLightbox from "glightbox";
import * as AOS from 'aos/dist/aos.js';
import { CountUp } from 'countup.js';
/** Include any other scripts here - this will combine them via Webpack for the final output script. */

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
import Lenis from 'lenis'

gsap.registerPlugin(ScrollTrigger, SplitText);

((window, document, $, undefined) => {

	/*******************************************************************************/
	/* MODULE
	/*******************************************************************************/

	const Base = (() => {

		/**
		 * Runs when the document is ready.
		 */
		const ready = () => {
			console.log('document ready!');

			AOS.init();

			const lightbox = GLightbox({
				touchNavigation: false,
				loop: false,
				autoplayVideos: true
			});

		};

		const smoothScrolling = () => {
			const lenis = new Lenis()
			
			lenis.on('scroll', ScrollTrigger.update)
			
			gsap.ticker.add((time)=>{
				lenis.raf(time * 1000)
			})
			
			gsap.ticker.lagSmoothing(0)

			function scrollToHash() {
				const hash = window.location.hash;
				
				if (hash) {
					const $targetElement = $(hash);
					const $siteHeader = $('.site-header');
			
					if ($targetElement.length && $siteHeader.length) {
						// Get the height of the site header
						const headerHeight = $siteHeader.outerHeight();
						
						// Calculate the target position, offset by the header height
						const targetPosition = $targetElement.offset().top - headerHeight;
			
						// Use Lenis to scroll to the target position
						lenis.scrollTo(targetPosition);
					}
				}
			}
			
			// Add hashchange event listener
			$(window).on('hashchange', function(event) {
				event.preventDefault();
				scrollToHash();
			});
			
			scrollToHash();
		}

		document.querySelectorAll('.fv-video').forEach(block => {
			const thumbnail = block.querySelector('.thumbnail');
			const playBtn = block.querySelector('.play-btn');
			const video = block.querySelector('.video');
			const isAutoplayMuted = block.querySelector('.video-container.is-autoplay-muted');

			const hidePlaceholder = () => {
				if (thumbnail) thumbnail.classList.add('is-hidden');
			};

			// Autoplay muted: keep thumbnail as a loading placeholder, hide once playback starts
			if (isAutoplayMuted && thumbnail && video) {
				if (video.classList.contains('local')) {
					video.addEventListener('playing', hidePlaceholder, { once: true });
				} else if (video.classList.contains('vimeo')) {
					const onVimeoMessage = (event) => {
						if (!event.origin.includes('vimeo.com')) return;
						let data = event.data;
						if (typeof data === 'string') {
							try { data = JSON.parse(data); } catch (e) { return; }
						}
						if (data && (data.event === 'play' || data.event === 'playing')) {
							hidePlaceholder();
							window.removeEventListener('message', onVimeoMessage);
						}
					};
					window.addEventListener('message', onVimeoMessage);
					// Fallback if play events aren't received (e.g. background mode)
					video.addEventListener('load', () => {
						setTimeout(hidePlaceholder, 800);
					}, { once: true });
				}
				return;
			}

			if (thumbnail) {
				thumbnail.addEventListener('click', () => {
					thumbnail.style.display = 'none';
					if (playBtn) playBtn.style.display = 'none';

					if (video.classList.contains('youtube')) {
						// PostMessage API for YouTube
						video.contentWindow.postMessage(JSON.stringify({
							event: 'command',
							func: 'playVideo',
							args: []
						}), '*');
					} else if (video.classList.contains('vimeo')) {
						// PostMessage API for Vimeo
						video.contentWindow.postMessage({ method: 'play' }, '*');
					} else if (video.classList.contains('local')) {
						video.play();
					}
				});
			}
		});

		const headerJS = () => {
			$('.hamburger').on('click', function () {
				$('html').toggleClass('menu-active');
				$('.mobile-menu, .hamburger').toggleClass('active');
				$('html').toggleClass('html-overflow-hidden');
			})

			$(document).on('keydown', function(e) {
				if (e.key === "Escape" || e.keyCode === 27) {
					$('html').removeClass('menu-active html-overflow-hidden');
					$('.mobile-menu, .hamburger, .site-header').removeClass('active');
				}
			});

			$('.site-header__menu-mobile .menu-item-has-children >.main-menu-item').on('click', function (e) {
				e.preventDefault();
				const curMenuItem = $(this).parents('.menu-item');
				if(!curMenuItem.hasClass('active')) {
						// $('.site-header .menu-item .sub-menu').stop().slideUp();
						$('.site-header .menu-item').removeClass('active')
				}
				// curMenuItem.find('.sub-menu').stop().slideToggle();
				curMenuItem.find('.sub-page').toggleClass('active');
				curMenuItem.toggleClass('active');
		
		});    

			// Handle clicking the back button to close the submenu
			$('.site-header__menu-mobile .sub-page .back').on('click', function (e) {
					e.preventDefault(); // Prevent the default action

					// Find the parent .sub-page and remove the .active class
					$(this).closest('.sub-page').removeClass('active');
			});

			var lastScroll = $(window).scrollTop();
		
			$(document).on("scroll", function () {
				var currentScroll = $(window).scrollTop();
				var scrollThreshold = $(window).width() < 768 ? 150 : 200;
		
				if (currentScroll > scrollThreshold) {
					$(".site-header").addClass("scrolling");
				} else {
					$(".site-header").removeClass("scrolling");
				}

				if (currentScroll) {
					$(".site-header").toggleClass("up", lastScroll > currentScroll);
				} else {
					$(".site-header").removeClass("up");
				}
		
				lastScroll = currentScroll;
			});
		};

		/**
		 * Runs when the window is loaded.
		 */
		const accordionJS = () => {
			const $wrappers = $('.accordions-wrapper, [data-accordion]');
			if (!$wrappers.length) return;

			const getTriggers = ($wrapper) => $wrapper.find('.accordion-heading');
			const getPanel = ($trigger) => {
				const panelId = $trigger.attr('aria-controls');
				if (panelId) {
					const $byId = $('#' + panelId);
					if ($byId.length) return $byId;
				}
				return $trigger.closest('.accordion-item, .faq-relationship__item').find('.accordion-content').first();
			};

			const setClosedState = ($trigger, $panel) => {
				$trigger.removeClass('active').attr('aria-expanded', 'false');
				$panel.attr('aria-hidden', 'true').attr('hidden', true);
			};

			const setOpenState = ($trigger, $panel) => {
				$trigger.addClass('active').attr('aria-expanded', 'true');
				$panel.removeAttr('hidden').attr('aria-hidden', 'false');
			};

			const closeTrigger = ($trigger, animate = true) => {
				const $panel = getPanel($trigger);
				if (!$panel.length) return;

				$trigger.removeClass('active').attr('aria-expanded', 'false');
				$panel.attr('aria-hidden', 'true');

				if (animate) {
					$panel.stop(true, true).slideUp(300, function () {
						$(this).attr('hidden', true);
					});
				} else {
					$panel.hide().attr('hidden', true);
				}
			};

			const openTrigger = ($trigger, animate = true) => {
				const $panel = getPanel($trigger);
				if (!$panel.length) return;

				setOpenState($trigger, $panel);

				if (animate) {
					$panel.stop(true, true).hide().slideDown(300);
				} else {
					$panel.show();
				}
			};

			const toggleTrigger = ($trigger, $wrapper) => {
				const isOpen = $trigger.attr('aria-expanded') === 'true';

				// Close any other open items in this accordion
				getTriggers($wrapper).not($trigger).each(function () {
					if ($(this).attr('aria-expanded') === 'true') {
						closeTrigger($(this));
					}
				});

				if (isOpen) {
					closeTrigger($trigger);
				} else {
					openTrigger($trigger);
				}
			};

			$wrappers.each(function () {
				const $wrapper = $(this);
				const $triggers = getTriggers($wrapper);

				// Ensure initial closed state
				$triggers.each(function () {
					const $trigger = $(this);
					const $panel = getPanel($trigger);
					if ($trigger.attr('aria-expanded') === 'true') {
						setOpenState($trigger, $panel);
						$panel.show();
					} else {
						setClosedState($trigger, $panel);
						$panel.hide();
					}
				});

				$triggers.off('click.accordion').on('click.accordion', function (e) {
					e.preventDefault();
					toggleTrigger($(this), $wrapper);
				});

				$triggers.off('keydown.accordion').on('keydown.accordion', function (e) {
					const $triggersList = getTriggers($wrapper);
					const index = $triggersList.index(this);
					let nextIndex = null;

					switch (e.key) {
						case 'ArrowDown':
							e.preventDefault();
							nextIndex = (index + 1) % $triggersList.length;
							break;
						case 'ArrowUp':
							e.preventDefault();
							nextIndex = (index - 1 + $triggersList.length) % $triggersList.length;
							break;
						case 'Home':
							e.preventDefault();
							nextIndex = 0;
							break;
						case 'End':
							e.preventDefault();
							nextIndex = $triggersList.length - 1;
							break;
						case 'Escape':
							if ($(this).attr('aria-expanded') === 'true') {
								e.preventDefault();
								closeTrigger($(this));
							}
							break;
						default:
							break;
					}

					if (nextIndex !== null) {
						$triggersList.eq(nextIndex).trigger('focus');
					}
				});
			});
		};

		const countUp = () => {
			const observer = new IntersectionObserver(
					(entries, observer) => {
							entries.forEach((entry) => {
									if (entry.isIntersecting) {
											const $this = $(entry.target);
											let rawStat = $this.data("stat"); // Get raw data-stat value
	
											// Ensure rawStat is a string
											if (typeof rawStat !== "string") {
													rawStat = String(rawStat); // Convert to string if it's not
											}
	
											// Use regex to extract numeric value, prefix, and suffix
											const match = rawStat.match(/^([^0-9\-]*)?([\d,\.]+)(.*)?$/); 
											if (!match || !match[2]) {
													console.error("Invalid data-stat format:", rawStat);
													return;
											}
	
											const prefix = match[1] || ""; // Optional Prefix
											const number = parseFloat(match[2].replace(/,/g, "")); // Numeric value
											const suffix = match[3] || ""; // Optional Suffix
	
											// Initialize CountUp options
											const options = {
													duration: 2.5,
													useEasing: true,
													useGrouping: true,
													separator: "",
													decimal: ".",
													prefix: prefix,
													suffix: suffix,
											};
	
											// Initialize CountUp
											const counter = new CountUp(entry.target, number, options);
	
											if (!counter.error) {
													counter.start();
											} else {
													console.error(counter.error);
											}
	
											// Stop observing once the animation has started
											observer.unobserve(entry.target);
									}
							});
					},
					{ threshold: 1 } // Trigger when 100% of the element is visible
			);
	
			// Observe each .stat element and set initial values
			$(".stat").each(function () {
					const $this = $(this);
					let rawStat = $this.data("stat");
					
					if (typeof rawStat !== "string") {
							rawStat = String(rawStat);
					}
					
					const match = rawStat.match(/^([^0-9\-]*)?([\d,\.]+)(.*)?$/);
					if (match && match[2]) {
							const prefix = match[1] || "";
							const suffix = match[3] || "";
							$this.text(prefix + "0" + suffix);
					}
					
					observer.observe(this);
			});
		};



		const swiperFunctions = () => {
			const swipers = $('.swiper');
			if (swipers.length) {
				swipers.each(function () {
					const $this = $(this);
					const swiperType = $this.data('swiper-type');
					switch (swiperType) {
						case 'homepage-hero':
							new Swiper($this.get(0), 
								{
									loop: true,
									autoplay: {
										delay: 5000,
										disableOnInteraction: false,
									},
								}
							);
							break;
						case 'testimonials': {
							if ($this.find('.swiper-slide').length < 2) {
								break;
							}

							let isAnimating = false;
							let autoplayTimer = null;
							const outDuration = 0.5;
							const inDuration = 0.55;
							const autoplayDelay = 5000;
							const $pagination = $this.find('.swiper-pagination');

							const swiperEl = $this.get(0);
							const swiper = new Swiper(swiperEl, {
								effect: 'fade',
								fadeEffect: {
									crossFade: true,
								},
								speed: 0,
								loop: true,
								allowTouchMove: false,
								autoplay: false,
								pagination: {
									el: $pagination.get(0),
									clickable: false,
								},
							});

							const stopAutoplay = () => {
								if (autoplayTimer) {
									clearInterval(autoplayTimer);
									autoplayTimer = null;
								}
							};

							const startAutoplay = () => {
								stopAutoplay();
								autoplayTimer = setInterval(() => {
									runTransition(() => swiper.slideNext());
								}, autoplayDelay);
							};

							const runTransition = async (changeSlide) => {
								if (isAnimating) return;
								isAnimating = true;
								stopAutoplay();

								const currentSlide = swiper.slides[swiper.activeIndex];
								const currentContent = currentSlide.querySelector('.testimonials-carousel__content');
								const currentImage = currentSlide.querySelector('.testimonials-carousel__image');
								const currentBackground = currentSlide.querySelector('.testimonials-carousel__background');

								// Keep upcoming slides hidden so the swap doesn't flash
								swiper.slides.forEach((slide, index) => {
									if (index === swiper.activeIndex) return;
									const content = slide.querySelector('.testimonials-carousel__content');
									const image = slide.querySelector('.testimonials-carousel__image');
									const background = slide.querySelector('.testimonials-carousel__background');
									if (content) gsap.set(content, { opacity: 0 });
									if (image) gsap.set(image, { scale: 0.9, opacity: 0 });
									if (background) gsap.set(background, { opacity: 0 });
								});

								changeSlide();

								const nextSlide = swiper.slides[swiper.activeIndex];
								const nextContent = nextSlide.querySelector('.testimonials-carousel__content');
								const nextImage = nextSlide.querySelector('.testimonials-carousel__image');
								const nextBackground = nextSlide.querySelector('.testimonials-carousel__background');

								// Keep the outgoing slide visible so text can cross-fade
								gsap.set(currentSlide, { opacity: 1, zIndex: 1 });
								gsap.set(nextSlide, { zIndex: 2 });
								if (nextContent) gsap.set(nextContent, { opacity: 0 });
								if (nextImage) gsap.set(nextImage, { scale: 0.9, opacity: 0 });
								if (nextBackground) gsap.set(nextBackground, { opacity: 0 });

								const outTimeline = gsap.timeline();
								if (currentContent) {
									outTimeline.to(currentContent, {
										opacity: 0,
										duration: outDuration,
										ease: 'none',
									}, 0);
								}
								if (nextContent) {
									outTimeline.to(nextContent, {
										opacity: 1,
										duration: outDuration,
										ease: 'none',
									}, 0);
								}
								if (currentImage) {
									outTimeline.to(currentImage, {
										scale: 0.9,
										opacity: 0,
										duration: outDuration,
										ease: 'power2.in',
									}, 0);
								}
								if (currentBackground) {
									outTimeline.to(currentBackground, {
										opacity: 0,
										duration: outDuration,
										ease: 'power2.in',
									}, 0);
								}
								await outTimeline;

								gsap.set(currentSlide, { opacity: 0, clearProps: 'zIndex' });
								gsap.set(nextSlide, { clearProps: 'zIndex' });
								if (currentContent) gsap.set(currentContent, { opacity: 1 });
								if (currentImage) gsap.set(currentImage, { scale: 1, opacity: 1 });
								if (currentBackground) gsap.set(currentBackground, { opacity: 1 });

								const inTimeline = gsap.timeline();
								if (nextImage) {
									inTimeline.to(nextImage, {
										scale: 1,
										opacity: 1,
										duration: inDuration,
										ease: 'power2.out',
									}, 0);
								}
								if (nextBackground) {
									inTimeline.to(nextBackground, {
										opacity: 1,
										duration: inDuration,
										ease: 'power2.out',
									}, 0);
								}
								await inTimeline;

								isAnimating = false;
								startAutoplay();
							};

							$pagination.on('click', '.swiper-pagination-bullet', function (e) {
								e.preventDefault();
								const index = $(this).index();
								if (index === swiper.realIndex) return;
								runTransition(() => swiper.slideToLoop(index));
							});

							const swipeThreshold = 50;
							let touchStartX = 0;
							let touchStartY = 0;

							swiperEl.addEventListener('touchstart', (e) => {
								const touch = e.changedTouches[0];
								touchStartX = touch.clientX;
								touchStartY = touch.clientY;
							}, { passive: true });

							swiperEl.addEventListener('touchend', (e) => {
								if (isAnimating) return;
								if (e.target.closest('a, button, .swiper-pagination')) return;

								const touch = e.changedTouches[0];
								const dx = touch.clientX - touchStartX;
								const dy = touch.clientY - touchStartY;

								if (Math.abs(dx) < swipeThreshold || Math.abs(dx) <= Math.abs(dy)) return;

								runTransition(() => {
									if (dx < 0) {
										swiper.slideNext();
									} else {
										swiper.slidePrev();
									}
								});
							}, { passive: true });

							startAutoplay();
							break;
						}
						case 'example-swiper':
							new Swiper($this.get(0), 
								{
									loop: true,
									spaceBetween: 100,
									autoplay: {
										delay: 5000,
										disableOnInteraction: false,
									},
									speed: 1000,
									pagination: {
										el: $this.parents('section').find('.swiper-pag').get(0),
										clickable: true,
									},
									navigation: {
										nextEl: $this.parents('section').find('.swiper-btn-next').get(0),
										prevEl: $this.parents('section').find('.swiper-btn-prev').get(0),
									},
								}
							);
							break;
					}
				});
			}
		};



		const animationsJS = () => {
			const animations = $('[data-animate]');
			if (animations.length) {
				animations.each(function () {
					const $this = $(this);
					const animationType = $this.data('animate');
					switch (animationType) {
						case 'fade-in':
							gsap.to($this, {
								opacity: 1,
								duration: 1,
								ease: 'power2.inOut',
								delay: $this.data('delay') || 0,
								scrollTrigger: {
									trigger: $this,
									start: 'top bottom',
								},
							});
							break;
						case 'fade-left':
							gsap.to($this, {
								opacity: 1,
								x: 0,
								duration: 1,
								ease: 'power2.inOut',
								delay: $this.data('delay') || 0,
								scrollTrigger: {
									trigger: $this,
									start: 'top bottom',
								},
							});
							break;
						case 'fade-right':
							gsap.to($this, {
								opacity: 1,
								x: 0,
								duration: 1,
								ease: 'power2.inOut',
								delay: $this.data('delay') || 0,
								scrollTrigger: {
									trigger: $this,
									start: 'top bottom',
								},
							});
							break;
						case 'fade-up':
							gsap.to($this, {
								opacity: 1,
								y: 0,
								duration: 1,
								ease: 'power2.inOut',
								delay: $this.data('delay') || 0,
								scrollTrigger: {
									trigger: $this,
									start: 'top bottom',
								},
							});
							break;
						case 'fade-down':
							gsap.to($this, {
								opacity: 1,
								y: 0,
								duration: 1,
								ease: 'power2.inOut',
								delay: $this.data('delay') || 0,
								scrollTrigger: {
									trigger: $this,
									start: 'top bottom',
								},
							});
							break;
							default:
								// If data-animate is set to 'class-on-scroll', add the class 'animated' on scroll into view
								ScrollTrigger.create({
									trigger: $this,
									start: 'top bottom',
									onEnter: () => {
										$this.addClass('animated');
									}
								});
								break;
					}
				});
			}
		};



		const load = () => {
			console.log('document load!');
		};

		/**
		 * The GiveWP modal donation form renders in a same-origin iframe wrapped by
		 * GiveWP's own `.givewp-donation-form-modal__overlay` on the parent page.
		 * That wrapper never reaches the iframe's own stylesheet (givewp-iframes-styles.scss
		 * loads inside the iframe's isolated document, which has no visibility into the
		 * parent document's DOM), so tag the iframe document itself once it loads and let
		 * that stylesheet target the tag instead.
		 */
		const givewpModalContextJS = () => {
			const taggedIframes = new WeakSet();

			const tagIframe = (iframe) => {
				if (taggedIframes.has(iframe)) return;
				taggedIframes.add(iframe);

				iframe.addEventListener('load', () => {
					try {
						iframe.contentDocument.documentElement.classList.add('is-modal-context');
					} catch (e) {
						// Cross-origin iframe - nothing we can do from the parent page.
					}
				});
			};

			const observer = new MutationObserver(() => {
				document.querySelectorAll('.givewp-donation-form-modal__overlay iframe').forEach(tagIframe);
			});

			observer.observe(document.body, { childList: true, subtree: true });
		};

		/**
		 * Return our module's publicly accessible functions.
		 */
		return {
			ready: ready,
			animationsJS: animationsJS,
			smoothScrolling: smoothScrolling,
			headerJS: headerJS,
			accordionJS: accordionJS,
			countUp: countUp,
			swiperFunctions: swiperFunctions,
			givewpModalContextJS: givewpModalContextJS,
			load: load
		};

	})();

	/*******************************************************************************/
	/* MODULE INITIALISE
	/*******************************************************************************/

	jQuery(document).ready(function($) {
		Base.ready();
		Base.animationsJS();
		Base.smoothScrolling(); // enable lenis smooth scrolling
		Base.accordionJS();
		Base.countUp();
		Base.headerJS();
		Base.swiperFunctions();
		Base.givewpModalContextJS();
	});

	jQuery(window).on('load', function($) {
		Base.load();
	});

})(window, document, jQuery);
